import RupIcons from "../../../RupIcons";
import { TooltipParent } from "../typings";

type Direction = "bottom" | "right";

export default class Tooltip {
	private _parent: TooltipParent; 
	private _container: JQuery;
	private _initialized = false;
	private _useParentContainer = false;
	private _direction: Direction;
	private _hasDetails = false;

	private get visible(): boolean {
		return Number(this._container.css("opacity")) === 1;
	}

	private set visible(value: boolean) {
		// non-strict comparison should be allowed here 
		if (value == this.visible) {
			this._container.css({
				"visibility": value ? "visible" : "hidden",
				"animation-name": "", 
				"opacity": value ? 1 : 0 
			});
			return;
		}
		this._container.css({
			"visibility": value ? "hidden" : "visible",
			"opacity": value ? 0 : 1,
			"animation-name": value ? "fadein" : "fadeout" 
		});
	}

	public get container(): JQuery {
		return this._container;
	}

	private setDialogContent(widget: JQuery): void {
		const [header, content] = this._parent.getTooltipInfoExtended();
		
		widget.find(".ui-dialog-titlebar-close")
			.empty().append(RupIcons.clear).removeAttr("title")
			.addClass("rup-icon-btn rup-icon-btn--lg rup-icon-btn--neutral");
		
		widget.find(".ui-dialog-title")
			.addClass("rup-dialog__title").empty().append(header);
	
		widget.find(".ui-dialog-content")
			.html(content.html()).attr("style", "");
	}

	private getTooltipContent(): JQuery {
		const content = this._parent.getTooltipInfo();
		if (this._hasDetails) {
			content.append($("<button>")
				.addClass("rup-global-search__tooltip-see-details")
				.text(GlobalSearchLabels.SeeDetails) 
				.on("click", () => 
					this.showDialog()));
		}
		
		return content;
	}

	private showDialog(): void {
		const setDialogContent = this.setDialogContent.bind(this);

		$("<div>").dialog({
			modal: true,
			resizable: false,
			draggable: false,
			buttons: [
				{
					text: GlobalSearchLabels.Done, 
					class: "rup-btn rup-btn--contained rup-btn--lg",
					click: function() {
						$(this).dialog("close");
					}
				}
			],
			open: function() {
				const zIndex = 90500;
				const widget = $(this).dialog("widget")
					.addClass("rup-global-search__tooltip-dialog")
					.attr("style", "")
					.css("z-index", zIndex + 1);

				$(".ui-widget-overlay").removeAttr("style")
					.css("z-index", zIndex);
				
				setDialogContent(widget);

				widget.css({
					left: `calc(50% - ${widget.outerWidth() / 2}px)`,
					top: `calc(50% - ${widget.outerHeight() / 2}px)`
				});
			},
			close: function() {
				$(this).dialog("destroy");
			}
		});
	}

	private calculatePosition(): [number, number] {
		const [top, left, width, height] = [
			this._parent.container.offset().top,
			this._parent.container.offset().left,
			this._parent.container.outerWidth(),
			this._parent.container.outerHeight()
		];
		
		const [tooltipWidth, tooltipHeight] = [
			this._container.outerWidth(),
			this._container.outerHeight()
		];

		const tooltipShift = 14;
	
		let [resTop, resLeft] = 
			this._direction === "bottom" ? 
				[height + tooltipShift, (width - tooltipWidth) / 2]
			: this._direction === "right" ?
				[(height - tooltipHeight) / 2, width + tooltipShift]
			: [0, 0];

		if (!this._useParentContainer) {
			[resTop, resLeft] = [resTop + top, resLeft + left];
		}

		return [resTop, resLeft]; 
	}

	private initialize(): void {
		this._container = $("<div>")
			.addClass("rup-global-search chip-tooltip")
			.attr("search-box-tooltip", "true")
			.append($("<div>")
				.addClass(this._direction))
			.append(this.getTooltipContent())
			.appendTo(this._useParentContainer ? 
				this._parent.container : document.body);
		
		const [top, left] = this.calculatePosition();

		this._container.css({
			"top": `${top}px`,  
			"left": `${left}px`,
			"opacity": 0
		});

		if (!this._useParentContainer) {
			this._container
				.on("mouseover", event => 
					this.toggleVisibility(event))
				.on("mouseout", event => 
					this.toggleVisibility(event));
		}

		this._initialized = true;
	}
	
	public constructor(
		parent: TooltipParent, 
		useParentContainer = true, 
		direction: Direction = "bottom",
		hasDetails = false) {
		this._parent = parent;
		this._useParentContainer = useParentContainer;
		this._direction = direction;
		this._hasDetails = hasDetails;
	}
	
	public dispose(): void {
		if (this._initialized) {
			this._container?.remove();
			this._container = null;
		}
	}

	public toggleVisibility(event: JQueryKeyEventObject): void {
		if (!this._initialized) {
			this.initialize();
		}
		this.visible = event.type === "mouseover";
	}
}
